var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6667 9.90755C17.6667 13.9576 14.3834 17.2409 10.3333 17.2409C6.28325 17.2409 3 13.9576 3 9.90755C3 5.85746 6.28325 2.57422 10.3333 2.57422C14.3834 2.57422 17.6667 5.85746 17.6667 9.90755ZM18.6667 9.90755C18.6667 14.5099 14.9357 18.2409 10.3333 18.2409C5.73096 18.2409 2 14.5099 2 9.90755C2 5.30518 5.73096 1.57422 10.3333 1.57422C14.9357 1.57422 18.6667 5.30518 18.6667 9.90755Z",
    fill: "#A0AEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34885 6.15444L9.33386 6.14551L10.2547 11.1425L10.6683 8.60493L10.8952 7.21326L11.5957 8.43695L12.173 9.44539H14.7969V10.4454H11.8832H11.5933L11.4492 10.1938L11.4284 10.1575L10.7783 14.1457L9.79313 14.1558L8.86846 9.138L8.50091 11.3579L8.22009 13.0539L7.54748 11.4718L7.11111 10.4454H4.79688V9.44539H7.44185H7.7726L7.79516 9.49847L8.34885 6.15444Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/InProgress.460496b5e7763bb365622b0e8856a5f7.svg";
export { ForwardRef as ReactComponent };